import React, {Component} from 'react';
import {connect} from 'react-redux';
import {dash_action_logged} from '../../store/actions/admin';
import queryString from 'query-string';

import LogRocket from 'logrocket';
import swal from 'sweetalert';

import {
    FormGroup,
    TextInput,
    Grid,
    Row,
    Column,
    Button,
    ComposedModal,
    ModalHeader,
    ModalBody,
    ModalFooter, Loading
} from "carbon-components-react"
import {ChevronRight24} from "@carbon/icons-react"

import "./index.scss"
import {ReactComponent as K_SVG} from "./assets/K_SVG.svg"
import data from "../../data"
import {Auth} from 'aws-amplify';

let bgStyle = {
    background: "transparent linear-gradient(180deg, " + process.env.REACT_APP_BG_COLOR_CLIENT1 + " 0%, " + process.env.REACT_APP_BG_COLOR_CLIENT2 + " 100%) 0% 0% no-repeat padding-box",
};
const reg = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\\w\\s]).{8,}$");

class Recovery extends Component {
    state = {};

    async componentDidMount() {
        //  const params = new URLSearchParams(((window.location.hash.substring(1).split("#",1))+"?").split("?",1));
        //  console.log(params);

        let params = new URL(window.location.href.replace(/#/g, "?"));


        console.log(params);
        let token = params.searchParams.get('id_token');
        let expiresIn = params.searchParams.get('expires_in');
        let identity_id = ''
        //alert(token);
        /*     const {
                 token, // the token you get from the provider
                 domainOrProviderName, // Either the domain of the provider(e.g. accounts.your-openid-provider.com) or the provider name, for now the library only supports 'google', 'facebook', 'amazon', 'developer'
                 expiresIn, // the time in ms which describes how long the token could live
                 user,  // the user object you defined, e.g. { username, email, phone_number }
                 identity_id // Optional, the identity id specified by the provider
             } = getFromProvider(); // arbitrary fu

     */
        console.log(params.searchParams.get('id_token'));
        Auth.federatedSignIn(
            "cognito-idp.us-east-1.amazonaws.com/us-east-1_j8YgsSTs2",
            {
                token,
                identity_id, // Optional
                expires_at: expiresIn * 1000 + new Date().getTime() // the expiration timestamp
            },
            'email'
        ).then(cred => {
            console.log(cred);
           // alert('0A');
            // If success, you will get the AWS credentials
            return Auth.currentAuthenticatedUser();

        }).then(user => {
            // If success, the user object you passed in Auth.federatedSignIn
            console.log(user.attributes);
            //alert('B');
            /*LogRocket.identify(user.username, {
                name: user.attributes.email,
                email: user.attributes.email,
                SISTEMA: process.env.REACT_APP_NAME,
                'SISTEMA-TENANT_ID': process.env.REACT_APP_X_TENANT_ID,
            });*/
            const token = user.token;
            // const email = user.attributes.email;
            // const name = user.username;
            // localStorage.setItem('tbClientes', email);
            localStorage.setItem('token', token);
            //  localStorage.setItem('nameSession', name);

            const userdash = this.props.getDashUser();

            userdash.then(userdash => {
              //  alert('AA');
                let dashs = JSON.parse(localStorage.getItem('dashboards'));
                this.props.history.push('/ij/painel/' + dashs[0].dashboardId);
            })

            console.log(user);
        }).catch(e => {
            console.log(e)


        });

    }


    render() {
        return <>
            <Loading
                description="Active loading indicator" withOverlay={true}
            />
        </>;
    }
}

const mapStateToProps = ({users}) => users;

const mapDispatchToProps = dispatch => ({
    getDashUser: () => dispatch(dash_action_logged())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Recovery);
